import { lazily } from '@mkmp/core'
import { ContentLayout } from '@/features/layout/ContentLayout'

const { Home } = lazily(() => import('@/features/home/routes/Home'))

/**
 * 用户路由
 */
export default [
  {
    id: Symbol('home'),
    path: '/home',
    element: <ContentLayout />,
    children: [
      {
        id: Symbol('home'),
        index: true,
        handle: {
          code: 'org-home'
        },
        element: <Home />
      }
    ]
  }
]
